import React, { Component } from 'react';
import Dropdown from 'react-dropdown';
import {ALWAYS_ON, ALWAYS_OFF, SYNCED} from 'effects/live/constants.js';

class RollEffectComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            effect: props.effect,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        this.state.effect = nextProps.effect;
        return true;
    }

    handleModeChange(mode) {
        this.state.effect.mode = mode.value;
        this.setState(this.state);
    }

    handleFactorChange(rollFactor) {
        this.state.effect.rollFactor = rollFactor.value;
        this.setState(this.state);
    }

    isEnabled() {
        return this.props.automation !== undefined ? true :
            this.state.effect.isEnabled();
    }

    render() {
        let className = this.props.automation !== undefined ?
            'enabled effect effect-automation' :
            this.state.effect.isEnabled() ? 'effect enabled' :
            'effect disabled';
        return (
            <div>
              {!this.isEnabled() ? '' :
                  <div>
                        <div className="lfo-rate-dropdown roll-factor">
                              <div className="lfo-rate-label">
                                    Mode:
                              </div>
                              <Dropdown
                                        className='osc-type-dropdown roll-factor-dropdown'
                                        controlClassName='osc-type-control-dropdown'
                                        arrowClassName='osc-type-arrow-dropdown'
                                        options={modeOptions}
                                        onChange={(o) => this.handleModeChange(o)}
                                        value={getModeOption(this.state.effect.mode)}
                                        placeholder="Rate" />
                                    <div className="clear-fix"/>


                            </div>
                        <div className="lfo-rate-dropdown roll-factor">
                              <div className="lfo-rate-label">
                                    Roll Factor:
                              </div>
                              <Dropdown
                                    className='osc-type-dropdown roll-factor-dropdown'
                                    controlClassName='osc-type-control-dropdown'
                                    arrowClassName='osc-type-arrow-dropdown'
                                    options={factorOptions}
                                    onChange={(o) => this.handleFactorChange(o)}
                                    value={getFactorOption(this.state.effect.rollFactor)}
                                    placeholder="Rate" />
                                    <div className="clear-fix"/>
                            </div>
                </div>} 
            </div>
        );
    }
}

const factorOptions = [
    {value: 0.125, label:'1/8'},
    {value: 0.25, label:'1/4'},
    {value: 0.5, label:'1/2'},
    {value: 1, label:'1'},
    {value: 2, label:'2'},
    {value: 4, label:'4'},
    {value: 8, label:'8'},
];

function getFactorOption(value) {
    return factorOptions.filter(
        option => option.value === value)[0];
}

const modeOptions = [
    {value: SYNCED, label:'Sync'},
    {value: ALWAYS_ON, label:'On'},
    {value: ALWAYS_OFF, label:'Off'},
];

function getModeOption(value) {
    return modeOptions.filter(
        option => option.value === value)[0];
}

export default RollEffectComponent;
